/**
 * @type {Record<string, import("react").CSSProperties>}
 */
export const fontStyles = {
  h1: {
    fontSize: "34px",
    fontWeight: 600,
    lineHeight: "56.1px",
  },
  h2: {
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "36px",
  },
  h3: {
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: "30px",
  },
  h4: {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "26.4px",
  },
  "h4-bold": {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "26.4px",
  },
  label: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "23.1px",
  },
  "label-semibold": {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "23.1px",
  },
  "label-xs": {
    fontSize: "10px",
    fontWeight: 500,
    lineHeight: "16.5px",
  },
  "label-small": {
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
  },
  "label-small-semibold-100%": {
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "12px",
  },
  "label-small-semibold": {
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "18px",
  },
  "label-100%": {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "14px",
  },
  "label-semibold-100%": {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "14px",
  },
  content: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "23.1px",
  },
  "content-price": {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "31.5px",
  },
  "content-semibold": {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "23.1px",
  },
  "content-bold": {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "23.1px",
  },
  "content-m": {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "26.4px",
  },
  "content-m-medium": {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "26.4px",
  },
  "content-m-semibold": {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "26.4px",
  },
  "content-m-item": {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "23.2px",
  },
  "content-l": {
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "27px",
  },
  "content-l-medium": {
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "27px",
  },
  "content-l-semibold": {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "27px",
  },
  "content-xl": {
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "25px",
  },
  "content-s": {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
  },
  "content-s-125%": {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "15px",
  },
  "content-s-semibold-125%": {
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "15px",
  },
  "content-xs": {
    fontSize: "10px",
    fontWeight: 400,
    lineHeight: "15px",
  },
  "content-email-xs": {
    fontSize: "9px",
    fontWeight: 400,
    lineHeight: "13.5px",
  },
  toast: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "17.5px",
  },
  "toast-small": {
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16.2px",
  },
  "toast-bold": {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "17.5px",
  },
  "button-xs": {
    fontSize: "10px",
    fontWeight: 500,
    lineHeight: "10px",
    letterSpacing: "0.01em",
  },
  "button-s": {
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "12px",
    letterSpacing: "0.01em",
  },
  "button-normal": {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "14px",
    letterSpacing: "0.01em",
  },
  "button-underline": {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "14px",
    letterSpacing: "0.01em",
    textDecoration: "underline",
  },
  "button-m": {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "0.01em",
  },
  "button-m-underline": {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "0.01em",
  },
  "button-xl": {
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: "25px",
  },
};
